
import Vue from 'vue'
import eventBus from '@/common/utils/eventBus'
import { APP_EVENTS } from '@/common/constants'
import { getJsonData } from '@/common/utils/dom'
import { Snackbar } from '@raksul/raksul-common-ui'

export default Vue.extend({
  components: {
    Snackbar
  },
  data(): {
    favoritesCount: number,
    isShow: boolean
  } {
    return {
      favoritesCount: 0,
      isShow: false
    }
  },
  created() {
    this.favoritesCount = getJsonData('#applicationData').favorites_count || 0
    eventBus.$on(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, (count: number) => {
      if (this.favoritesCount < count) {
        this.isShow = true
      } else {
        this.isShow = false
      }
      this.favoritesCount = count
    })
  }
})
